import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { IMMEDIATE_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function ViewImmediateHelpPage() {
  useRequireSectionVisible("showUrgentHelp");
  return <CommunityViewPage section={IMMEDIATE_HELP} />;
}
